import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @todo
 * This component has issues that make it low in quality.
 * This should be addressed in future improvement work.
 */
class Toggle extends Component {
  constructor(props) {
    super(props);

    this.input = null;

    this.setInputRef = (element) => {
      this.input = element;
    };

    this.handleBlur = this.handleBlur.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleFocus = this.handleFocus.bind(this);

    let checked = false;

    if ('checked' in this.props) {
      checked = this.props.checked;
    } else if ('defaultChecked' in this.props) {
      checked = this.props.defaultChecked;
    }

    this.state = {
      checked: !!checked,
      hasFocus: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({ checked: !!nextProps.checked });
    }
  }

  handleBlur() {
    this.setState({ hasFocus: false });
  }

  handleClick(event) {
    const checkbox = this.input;

    if (event.target !== checkbox) {
      event.preventDefault();
      checkbox.focus();
      checkbox.click();
      return;
    }

    if (!('checked' in this.props)) {
      this.setState({ checked: checkbox.checked });
    }
  }

  handleFocus() {
    this.setState({ hasFocus: true });
  }

  render() {
    let classes = classNames('react-toggle', {
      'react-toggle--checked': this.state.checked,
      'react-toggle--focus': this.state.hasFocus,
      'react-toggle--disabled': this.props.disabled,
    });

    return (
      <div className={classes} onClick={this.handleClick}>
        <div className="react-toggle-track" />
        <div className="react-toggle-thumb" />

        <input
          ref={this.setInputRef}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          className="react-toggle-screenreader-only"
          type="checkbox"
          {...this.props}
        />
      </div>
    );
  }
}

Toggle.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  'aria-labelledby': PropTypes.string,
  'aria-label': PropTypes.string,
};

export { Toggle };
